import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Bell, BellOff } from "lucide-react";
import { pushSupported, getPushStatus, enablePush, disablePush } from "@/lib/push";

export function PushBellButton() {
  const [status, setStatus] = useState("default");
  const [busy, setBusy] = useState(false);
  useEffect(() => { getPushStatus().then(setStatus).catch(() => {}); }, []);
  if (!pushSupported()) return null;
  const on = status === "subscribed";
  const toggle = async () => {
    setBusy(true);
    try {
      if (on) { await disablePush(); setStatus("default"); toast.success("Notifiche disattivate su questo dispositivo"); }
      else { await enablePush(); setStatus("subscribed"); toast.success("Notifiche attive: riceverai un avviso per ogni messaggio"); }
    } catch (e) { toast.error(e.message || "Notifiche non attivate"); }
    setBusy(false);
  };
  return (
    <Button variant="ghost" size="sm" onClick={toggle} disabled={busy} data-testid="manager-push-btn"
      title={on ? "Notifiche attive" : "Attiva notifiche"}
      className={on ? "text-cyan-300 hover:text-white hover:bg-slate-800" : "text-slate-400 hover:text-white hover:bg-slate-800"}>
      {on ? <Bell className="w-4 h-4 sm:mr-1.5" /> : <BellOff className="w-4 h-4 sm:mr-1.5" />}
      <span className="hidden sm:inline">{on ? "Notifiche" : "Attiva notifiche"}</span>
    </Button>
  );
}
